import type React from "react";
import type { IEstimationDescription } from "~/pages/estimation";
import styles from "./index.module.scss";

interface Props {
  descriptions: IEstimationDescription[];
}

const EstimationDescription: React.FC<Props> = ({ descriptions }) => {
  return (
    <div className={styles["estimationDescription"]}>
      {descriptions.map((item, index) => (
        <div key={index} className={styles["estimationDescriptionItem"]}>
          <div className={styles["estimationDescriptionItemHeader"]}>
            <h2>ユースケース：</h2>
            <h2>{item.useCase}</h2>
          </div>
          <div className={styles["estimationDescriptionItemContent"]}>
            <div className={styles["estimationDescriptionItemContentRow"]}>
              <ul>
                <li className={styles["estimationDescriptionItemContentRowLabel"]}>詳細</li>
                <li className={styles["estimationDescriptionItemContentRowValue"]}>
                  <p>{item.description.details}</p>
                </li>
                <li className={styles["estimationDescriptionItemContentRowLabel"]}>算出理由</li>
                <li className={styles["estimationDescriptionItemContentRowValue"]}>
                  <p>{item.description.reason}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EstimationDescription;
